export function selectBestSupplierProductVariation<T extends {
  supplierName: string;
  calculatedCost: {
    destinationCountry: string;
    totalCostIncludingVAT: number;
    totalCostExcludingVAT: number;
    totalCostVAT: number;
    VATRate: number;
  }[];
  availableStock: {
    destinationCountry: string;
    availableStock: number;
  }[];
}>(
  forSupplierName: string,
  destinationCountry: string,
  supplierProductVariations: T[],
): T | undefined {
  const possibleSupplierProductVariations = supplierProductVariations.slice()
    .filter((supplierProductVariation) => (
      supplierProductVariation.supplierName === forSupplierName
    ));

  if (possibleSupplierProductVariations.length === 0) {
    return undefined;
  }

  const withStock = possibleSupplierProductVariations.filter((supplierProductVariation) => {
    const availableStock = supplierProductVariation.availableStock
      .find((availableStock) => (
        availableStock.destinationCountry === destinationCountry
      ));
    return (availableStock?.availableStock || 0) > 0;
  });

  const sorted = withStock
    .sort((a, b) => {
      const aCost = a.calculatedCost.find((cc) => cc.destinationCountry === destinationCountry);
      const bCost = b.calculatedCost.find((cc) => cc.destinationCountry === destinationCountry);
      if (!aCost || !bCost) {
        return 0;
      }
      return aCost.totalCostExcludingVAT - bCost.totalCostExcludingVAT;
    });

  return sorted[0];
}